export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Like-Gray-c20a1c0b43e87efbd0e843399a0d9c97.svg";